module.exports = __webpack_public_path__ + "static/media/MetaMaskIcon.94a36c52.svg";